import * as clsApi from "@/js/api/classroomApi";

export type TeacherGoogleSyncStatusRaw =
	| {
			// initial state - the teacher has never completed a google sync
			status: "";
	  }
	| {
			status: "running";
			startTime: string;
	  }
	| {
			status: "finished";
			startTime: string;
			endTime: string;
			classroomsMatched: number;
			studentsMatched: number;
	  }
	| {
			status: "error";
			startTime?: string;
			endTime?: string;
			errorMessage: string;
	  };

export type TeacherGoogleSyncStatus =
	| {
			// initial state - the teacher has never completed a google sync
			status: "";
	  }
	| {
			status: "running";
			startTime: Date;
	  }
	| {
			status: "finished";
			startTime: Date;
			endTime: Date;
			classroomsMatched: number;
			studentsMatched: number;
	  }
	| {
			status: "error";
			startTime?: Date;
			endTime?: Date;
			errorMessage: string;
	  };

function parseSyncStatusResponse(data: TeacherGoogleSyncStatusRaw): TeacherGoogleSyncStatus {
	if (data.status === "") {
		return data;
	}
	if (data.status === "running") {
		return { ...data, startTime: new Date(data.startTime) };
	}
	if (data.status === "finished") {
		return { ...data, startTime: new Date(data.startTime), endTime: new Date(data.endTime) };
	}
	if (data.status === "error") {
		const { startTime, endTime, ...rest } = data;
		return {
			...rest,
			startTime: startTime ? new Date(startTime) : undefined,
			endTime: endTime ? new Date(endTime) : undefined,
		};
	}
	throw new Error("Invalid sync status");
}

export async function getTeacherGoogleSyncStatus(): Promise<TeacherGoogleSyncStatus> {
	const data = await clsApi.Get2<TeacherGoogleSyncStatusRaw>(`v1/teachers/sync/google/classrooms/status`);
	return parseSyncStatusResponse(data);
}

export async function startTeacherGoogleSync(): Promise<void> {
	await clsApi.Put2(`v1/teachers/sync/google/classrooms`, {});
}
